<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>达人管理</a-breadcrumb-item>
    <a-breadcrumb-item>待处理提现单</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 操作 -->
      <a-col :span="24">
        <a-row>
          <a-col :span="0" class="tool-title"></a-col>
          <a-col :span="24" style="white-space: nowrap; text-align: right;">
            <a-button style="margin-left: 16px" @click="touchDownload">导出数据</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 多选组件 -->
  <TableCheckbox
    sourceKey="id"
    :dataSource="dataSource"
    :selectedRowKeys="selectedRowKeys"
    :selectedRows="selectedRows"
    :pagination="pagination"
    :isLoading="isLoading"
  >
    <!-- 按钮文案 -->
    <template #checkbox>
      <!-- 完成打款 -->
      <a-button style="margin-left: 10px;" @click="touchBatchSuccess(selectedRowKeys, selectedRows)">完成打款</a-button>
      <!-- 打款失败 -->
      <!-- <a-button style="margin-left: 10px;" @click="touchBatchFail(selectedRowKeys)">打款失败</a-button> -->
    </template>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 操作 -->
        <template v-if="column.key === 'operation'">
          <a class="operation-item" @click="touchBatchSuccess([record.id], [record])">完成打款</a>
          <a-popconfirm
            ok-text="确定"
            cancel-text="取消"
            @confirm="touchBatchFail([record.id])"
          >
            <template #icon>
              <a-textarea
                style="width: 200px;"
                v-model:value="failedReason"
                placeholder="请输入失败原因"
                :auto-size="{ minRows: 2, maxRows: 2 }"
              />
            </template>
            <a class="operation-item">打款失败</a>
          </a-popconfirm>
          <a class="operation-item" @click="touchPayInfo(record)">收款信息</a>
        </template>
      </template>
    </a-table>
  </TableCheckbox>
  <PayInfoModal ref="RefPayInfoModal"></PayInfoModal>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import * as Ex from "@netjoy/excelex"
import { message, Modal } from 'ant-design-vue'
import PayInfoModal from './components-cash-pending/PayInfoModal.vue'
import { darenWithdrawList, darenWithdrawSuccess, darenWithdrawFail } from '@/api/request'
import TableCheckbox from '@/components/TableCheckbox'

// 打款信息
let RefPayInfoModal = ref(null)
// 加载
let isLoading = ref(false)
// 失败原因
let failedReason = ref(undefined)
// 选中
let selectedRowKeys = ref([])
let selectedRows = ref([])
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '提交时间',
    dataIndex: 'created_at',
    key: 'created_at',
  },
  {
    title: 'UID',
    dataIndex: 'uid',
    key: 'uid',
  },
  {
    title: '昵称',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: '提现金额',
    dataIndex: 'cash_amount',
    key: 'cash_amount',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
  }
])

onBeforeMount (() => {
  // 初始化选择项列表
  getSelectList()
  // 初始化获取
  touchSearch()
})

// 初始化选择项列表
function getSelectList () {
  // channelSelectList().then(res => {
  //   const { code, data } = res
  //   if (code === 0) {
  //     channels.value = data
  //   }
  // })
}

// 打款信息
function touchPayInfo(record) {
  RefPayInfoModal.value.showModal(record)
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getList()
}

// 多选处理
function onSelectChange (rowKeys, rows) {
  selectedRowKeys.value = rowKeys
  selectedRows.value = rows
}

// 查询
function touchSearch () {
  // 调整参数
  pagination.current = 1
  // 获取列表
  getList()
}

// 批量操作完成打款
function touchBatchSuccess (ids, objs) {
  if (ids.length) {
    touchSuccess(ids, objs);
  } else {
    message.error('请选择提现单')
  }
}

// 批量操作打款失败
function touchBatchFail (ids) {
  if (ids.length) {
    touchFail(ids);
  } else {
    message.error('请选择提现单')
  }
}

// 完成打款
function touchSuccess (ids, objs) {
  Modal.confirm({
    title: '确定完成打款吗?',
    onOk() {
      darenWithdrawSuccess({ids: ids}).then(res => {
        const { code } = res
        if (code === 0) {
          message.success('操作成功')
          getList()
        } else {
          message.error(res.message)
        }
      })
    },
  });
}

// 打款失败
function touchFail (ids) {
  darenWithdrawFail({id: ids[0], reason: failedReason.value}).then(res => {
    const { code, msg } = res
    if (code === 0) {
      message.success('操作成功')
      // 更新列表
      getList()
    }
  })
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    type: 0,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  darenWithdrawList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
      // 清空选中
      selectedRowKeys.value = []
      selectedRows.value = []
    }
  }).catch(() => {
    isLoading.value = false
  })
}

function touchDownload () {
  isLoading.value = true
  const params = {
    type: 2,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  darenWithdrawList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      const list = data.data
      if (list.length) {
        const columns = [
          {
            name: '收款方账户名称',
            field: 'real_name'
          },
          {
            name: '身份证',
            field: 'id_number'
          },
          {
            name: '收款方账号',
            field: 'bank_account'
          },
          {
            name: '实发金额',
            field: 'cash_amount'
          },
          {
            name: '手机号',
            field: 'phone'
          },
        ]
        const sheets = [
          {
            data: list,
            columns: columns
          }
        ]
        Ex.ex(sheets, function (item, field, json, sheetIndex, row, col, rowCount, colCount) {
          // row=0 为表头
          // if (row != 0) {
          //   // 金额处理
          //   if (field === 'wx_pay_amount' || field === 'dy_pay_amount') {
          //     if (item.data != '-') {
          //       item.data = Pub.KEEP_NUMBER_DECIMAL(item.data / 100, 2, false, true)
          //     }
          //     return item
          //   }
          // }
          // 无数据兼容
          // item.data = item.data || '-'
          return item
        },  `达人管理-待处理提现单`)
      } else {
        message.error('还没有可导出的内容')
      }
    } else {
      message.error('导出失败')
    }
  }).catch(() => {
    message.error('导出失败')
  })
}
</script>

<style scoped>
.cover-img {
  display: inline-block;
  width: 40px;
  height: 40px;
}
.cover-title {
  margin-left: 10px;
}
</style>